import { plural } from 'pluralize';
import { useEffect, useState } from 'react';

/**
 * Hook to pluralize words
 * @param word The word to pluralize
 * @param initialValue Optional initial value for the pluralized word
 * @returns The pluralized word, updated when the word changes
 */
export const usePluralize = (word: string, initialValue?: string): string => {
	const [pluralizedWord, setPluralizedWord] = useState<string>(initialValue ?? plural(word));

	useEffect(() => {
		if (!initialValue) {
			setPluralizedWord(plural(word));
		}
	}, [word, initialValue]);

	return pluralizedWord;
};
